export default {
  // list
  'config.query.configName': '参数名称',
  'config.query.configName.placeholder': '输入要查找的参数名称',
  'config.query.configKey': '参数键名',
  'config.query.configKey.placeholder': '输入要查找的参数键名',
  'config.query.configType': '系统内置',
  'config.column.configName': '参数名称',
  'config.column.configKey': '参数键名',
  'config.column.configValue': '参数键值',
  'config.column.configType': '系统内置',
  'config.column.configType.yes': '是',
  'config.column.configType.no': '否',
  'config.column.remark': '备注',
  // edit
  'config.edit.title': '修改参数配置',
  'config.add.title': '新增参数配置',
  'config.edit.success': '修改成功',
  'config.add.success': '新增成功',
  'config.form.configName': '参数名称',
  'config.form.configName.placeholder': '请输入参数名称',
  'config.form.configName.required': '参数名称不能为空',
  'config.form.configKey': '参数键名',
  'config.form.configKey.placeholder': '请输入参数键名',
  'config.form.configKey.required': '参数键名不能为空',
  'config.form.configValue': '参数键值',
  'config.form.configValue.placeholder': '请输入参数键值',
  'config.form.configValue.required': '参数键值不能为空',
  'config.form.configType': '系统内置',
  'config.form.configType.yes': '是',
  'config.form.configType.no': '否',
  'config.form.remark': '备注',
  'config.form.remark.placeholder': '请输入备注',
}
